import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CreateAgencyComponent } from './create-agency.component';
import{ TopUpComponent } from './top-up/top-up.component';
import { AuthGuardService } from '../shared/auth-guard.service';

const appRoutes : Routes = [
	{ path: '', component : CreateAgencyComponent},
  { path: 'topUp', component : TopUpComponent, canActivate: [ AuthGuardService ]}
]

@NgModule({
  imports: [
    RouterModule.forChild(appRoutes)
  ],
  exports: [RouterModule]
})
export class CreateAgencyRoutingModule { }



// WEBPACK FOOTER //
// C:/Agent0/_work/434/s/src/app/create-agency/create-agency-routing.module.ts